export default __webpack_public_path__ + "ea1ff627244763ab1c3d0fd17f7ff198.png";